// Generated by CoffeeScript 1.12.5
angular.module(__filename, []).factory('opsSites', [
  '$window', function($window) {
    var _getUrl;
    _getUrl = require('../sites').getUrl;
    return {
      getUrl: function(siteName, settings) {
        if (settings == null) {
          settings = $window.settings;
        }
        return _getUrl(siteName, settings);
      }
    };
  }
]);

module.exports = __filename;
